import { PortfolioWizardStepNames } from './types'

/**
 * Ordered list of the lease wizard steps that show a "N of M" indicator.
 *
 * This array is the single source of truth for the numbering — the position in
 * the array is the step number and the length is the total. Insert, remove or
 * reorder an entry and every step renumbers automatically. Screens that should
 * not show a step indicator (e.g. renewal, termination, decline) are simply
 * left out and must not call getStep.
 */
export const LEASE_WIZARD_STEPS: PortfolioWizardStepNames[] = [
  PortfolioWizardStepNames.type,
  PortfolioWizardStepNames.property,
  PortfolioWizardStepNames.owners,
  PortfolioWizardStepNames.applications,
  PortfolioWizardStepNames.tenants,
  PortfolioWizardStepNames.lease,
  PortfolioWizardStepNames.rent,
  PortfolioWizardStepNames.commission,
  PortfolioWizardStepNames.invoices,
  PortfolioWizardStepNames.settings,
  PortfolioWizardStepNames.activation,
]

/**
 * Returns the "N of M" step label for a wizard step, derived from its position
 * in LEASE_WIZARD_STEPS. Returns an empty string for steps not in the list,
 * which the ChatBot component treats as "no step" and hides.
 */
export const getStep = (name: PortfolioWizardStepNames): string => {
  const index = LEASE_WIZARD_STEPS.indexOf(name)
  return index === -1 ? '' : `${index + 1} of ${LEASE_WIZARD_STEPS.length}`
}
